import { createSelector } from 'reselect'
import { get } from 'lodash'
import { CONSENT_DELIVERY_TYPES, CONFIGURATION_KEYS } from 'constants/enums'

const inputConsentTypes = (consentTypes, configKeys) => ({
  consentTypes,
  configKeys
})

const mapForDropdown = ({ consentTypes = [], configKeys = [] } = {}) => {
  const positiveConfigKeys = configKeys.filter(key =>
    get(key, 'booleanValue', false)
  )

  if (positiveConfigKeys.length > 0) {
    return consentTypes.filter(type => {
      if (type.value === CONSENT_DELIVERY_TYPES.electronically.id) {
        return (
          positiveConfigKeys.filter(
            key =>
              key.configurationKey.keyName.value ===
              CONFIGURATION_KEYS
                .participantRegistrationParentalConsentElectronically.id
          ).length > 0
        )
      }
      if (type.value === CONSENT_DELIVERY_TYPES.paper.id) {
        return (
          positiveConfigKeys.filter(
            key =>
              key.configurationKey.keyName.value ===
              CONFIGURATION_KEYS.participantRegistrationParentalConsentPaper.id
          ).length > 0
        )
      }
      if (type.value === CONSENT_DELIVERY_TYPES.notRequired.id) {
        return (
          positiveConfigKeys.filter(
            key =>
              key.configurationKey.keyName.value ===
              CONFIGURATION_KEYS
                .participantRegistrationParentalConsentNotRequired.id
          ).length > 0
        )
      }
      return false
    })
  }

  return consentTypes
}

export default createSelector(inputConsentTypes, mapForDropdown)
